<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="masterList.tableQuery.search.reportDate"
              type="date"
              placeholder="请选择填报日期"
              style="width: 100%;"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.status"
              placeholder="请选择状态"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @dblclick="viewFun(arguments)"
        @view="viewFun(arguments)"
        @submit="submitFun(arguments)"
        @delete="deleteFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>
    <!-- 新增 修改-->
    <add-edit-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-title="dialogViewTitle"
      :dialog-visible.sync="dialogViewVisible"
      :master-table-key="masterList.tableKey"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 新增 修改
import AddEditDialog from './components/addEditDialog'
// 查看
import ViewDialog from './components/viewDialog'
import { loadSupplyUseEfficiencyInfoListDataApi, loadSupplyUseEfficiencyInfoExportDataApi, saveOrUpdateSupplyUseEfficiencyInfoApi } from '@/api/supplyUseEfficiencyInfo'
export default {
  name: 'SupplyUseEfficiencyInfo',
  components: {
    CustomTable,
    TableOperation,
    AddEditDialog,
    ViewDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'supply_use_efficiency_info_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['supply_use_efficiency_info_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['supply_use_efficiency_info_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['supply_use_efficiency_info_del'],
            prop: 'delete',
            label: '作废',
            method: 'delete'
          },
          {
            permissionSigns: ['supply_use_efficiency_info_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['supply_use_efficiency_info_submit'],
            prop: 'submit',
            label: '提交',
            method: 'submit'
          },
          {
            permissionSigns: ['supply_use_efficiency_info_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            reportDate: '',
            status: ''
          }
        }
      },
      id: null, // 选中的单据ID
      statusOptions: [{ data: 1, label: '制单' }, { data: 3, label: '提交' }],
      eventType: '',
      dialogAddEditTitle: '',
      dialogAddEditVisible: false,
      dialogViewTitle: '查看货源使用效率',
      dialogViewVisible: false
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'province_name', width: 80 },
      { prop: 'cityName', label: '城市', filterColumn: 'city_name', width: 80 },
      { prop: 'startDateStr', label: '开始时间', filterColumn: 'start_date', width: 110, isBetween: true },
      { prop: 'endDateStr', label: '结束时间', filterColumn: 'end_date', width: 110, isBetween: true },
      { prop: 'reportDateStr', label: '填报时间', filterColumn: 'report_date', width: 110, isBetween: true },
      { prop: 'statusStr', label: '状态', filterColumn: 'status', filterValue: 'status', filterArray: [{ label: '制单', value: 1 }, { label: '提交', value: 3 }], width: 100 },
      { prop: 'remark', label: '备注', filterColumn: 'bill.remark' },
      { prop: 'operatorName', label: '操作人', filterColumn: 'operator_name', width: 100 },
      { prop: 'operationTimeStr', label: '操作时间', filterColumn: 'operation_time', width: 160, isBetween: true }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadSupplyUseEfficiencyInfoListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 新增
    addFun () {
      this.eventType = 'add'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '新增货源使用效率'
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status === 3) {
        this.$message({
          message: '数据不在制单状态，不能修改',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '修改货源使用效率'
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.dialogViewVisible = !this.dialogViewVisible
    },
    // 提交
    submitFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status === 3) {
        this.$message({
          message: '数据不在制单状态，不能提交',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.$confirm('是否确定提交该数据？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateSupplyUseEfficiencyInfoApi({ id: args[0].id, status: 3, isSub: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 作废
    deleteFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status === 3) {
        this.$message({
          message: '数据不在制单状态，不能作废',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.$confirm('是否确定作废该数据？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateSupplyUseEfficiencyInfoApi({ id: args[0].id, status: 0, isDel: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadSupplyUseEfficiencyInfoExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
